/**
 * EPDM Liner Cart Protection
 * 
 * This script prevents customers from changing quantities of EPDM Liner products in the cart,
 * while preserving the ability to remove items.
 */

(function() {
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize protection on page load
    initEPDMCartProtection();
    
    // Set up recurring checks in case the cart gets updated dynamically
    setInterval(initEPDMCartProtection, 2000);
    
    // Also listen for standard cart events if available
    document.addEventListener('cart:refresh', initEPDMCartProtection);
    document.addEventListener('cart:updated', initEPDMCartProtection);
    document.addEventListener('drawer:open', initEPDMCartProtection);
  });
  
  // Main function to initialize EPDM cart protection
  function initEPDMCartProtection() {
    // Look for cart items
    const cartItems = document.querySelectorAll('[data-cart-item], .cart-item, .cart__item');
    
    cartItems.forEach(function(cartItem) {
      // Check if this is an EPDM item
      const isEPDM = isEPDMLineItem(cartItem);
      
      if (isEPDM) {
        // Find the quantity input
        const quantityInput = cartItem.querySelector('input[name^="updates"]');
        
        if (quantityInput && !quantityInput.getAttribute('data-locked')) {
          // Store the original value
          const originalValue = quantityInput.value;
          
          // Mark as locked to prevent double-processing
          quantityInput.setAttribute('data-locked', 'true');
          
          // Disable the input but keep it visible
          quantityInput.disabled = true;
          quantityInput.style.backgroundColor = '#f0f8ff';
          quantityInput.style.border = '1px solid #0066cc';
          quantityInput.style.cursor = 'not-allowed';
          quantityInput.style.color = '#0066cc';
          quantityInput.style.fontWeight = 'bold';
          
          // Remove increment/decrement buttons if they exist
          const quantityButtons = cartItem.querySelectorAll('.quantity__button, .quantity-adjuster__button, .plus, .minus, .quantity__button--plus, .quantity__button--minus');
          quantityButtons.forEach(button => {
            button.style.display = 'none';
          });
          
          // Add explanatory notice to the cart item
          if (!cartItem.querySelector('.epdm-quantity-notice')) {
            // Create the notice element with blue styling
            const noteElement = document.createElement('div');
            noteElement.className = 'epdm-quantity-notice';
            noteElement.style.color = '#0066cc';
            noteElement.style.fontSize = '0.9em';
            noteElement.style.padding = '8px 12px';
            noteElement.style.margin = '8px 0';
            noteElement.style.backgroundColor = '#f0f8ff';
            noteElement.style.borderLeft = '3px solid #0066cc';
            noteElement.style.borderRadius = '2px';
            noteElement.innerHTML = 'Length cannot be modified in cart. Please remove and re-select a new size if needed.';
            
            // Find the item details area to place the notice
            const itemDetails = 
              cartItem.querySelector('.cart-item__details, .cart-item__content, .cart__item-details, .cart__item-content') || 
              cartItem;
              
            // Insert notice at the top of the item details
            itemDetails.insertBefore(noteElement, itemDetails.firstChild);
          }
          
          // Add event listener to prevent manual changes
          quantityInput.addEventListener('change', function(e) {
            if (this.value != originalValue) {
              this.value = originalValue;
              alert('EPDM Liner lengths cannot be modified. Please remove the item and add a new selection with the desired length.');
            }
          });
        }
      }
    });
    
    // Also handle cart update API requests
    monitorCartAPIRequests();
  }
  
  // Determine if a cart item is an EPDM Liner product
  function isEPDMLineItem(cartItem) {
    // Define the specific variant SKUs for EPDM liners
    const epdmSKUs = ['CAR-10FT', 'CAR-15FT', 'CAR-20FT', 'CAR-25FT', 'CAR-30FT', 'CAR-40FT', 'CAR-50FT'];
    
    // Check if any of the EPDM SKUs appear in the cart item text
    const itemText = cartItem.textContent || '';
    
    for (let sku of epdmSKUs) {
      if (itemText.includes(sku)) {
        return true;
      }
    }
    
    return false;
  }
  
  // Monitor cart API requests to prevent quantity changes via AJAX
  function monitorCartAPIRequests() {
    const originalFetch = window.fetch;
    
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.includes('/cart/update.js') && options && options.body) {
        // Try to parse the request body
        try {
          let body = JSON.parse(options.body);
          
          if (body.updates) {
            // We need to check if any of these updates are for EPDM items
            // Since we don't have the cart data here, we'll fetch it first
            return fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                let needsBlocking = false;
                
                // Define the specific variant SKUs for EPDM liners
                const epdmSKUs = ['CAR-10FT', 'CAR-15FT', 'CAR-20FT', 'CAR-25FT', 'CAR-30FT', 'CAR-40FT', 'CAR-50FT'];
                
                // Check each item in the cart
                cart.items.forEach(item => {
                  // Check if this item has one of our EPDM SKUs
                  let isEPDMItem = false;
                  
                  if (item.properties && item.properties['SKU']) {
                    for (let sku of epdmSKUs) {
                      if (item.properties['SKU'].includes(sku)) {
                        isEPDMItem = true;
                        break;
                      }
                    }
                  }
                  
                  if (isEPDMItem) {
                    // This is an EPDM item, check if its quantity is being changed
                    const key = item.key;
                    // Allow setting to 0 (removing) but prevent any other changes
                    if (body.updates[key] && parseInt(body.updates[key]) !== item.quantity && parseInt(body.updates[key]) !== 0) {
                      // Quantity is being changed to something other than 0, prevent it
                      body.updates[key] = item.quantity;
                      needsBlocking = true;
                    }
                  }
                });
                
                if (needsBlocking) {
                  // Show an alert about why the change was prevented
                  setTimeout(() => {
                    alert('EPDM Liner lengths cannot be modified. Please remove the item and add a new selection with the desired length.');
                  }, 500);
                  
                  // Update the options with our modified body
                  options.body = JSON.stringify(body);
                }
                
                // Continue with the (potentially modified) request
                return originalFetch(url, options);
              });
          }
        } catch (e) {
          console.error("Error parsing cart update body:", e);
        }
      }
      
      // Default behavior for non-cart updates
      return originalFetch.apply(this, arguments);
    };
  }
})();